module.exports = __webpack_public_path__ + "img/dsci0015.cff3e390.jpg";